import { useEffect } from 'react';

import { FormikProvider, useFormik } from 'formik';

import Checkbox from 'components/shared/Checkbox/Checkbox';
import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

import ElavonCardForm from '../../PreAuthModal/components/ElavonCardForm';
import { buildBillingAddress } from '../../PreAuthModal/lib/preAuthFormHelpers';

const INITIAL_VALUES = {
  address_ln_1: '',
  address_ln_2: '',
  city: '',
  state: '',
  zip: ''
};

const ElavonManualEntry = ({ patientId, method }) => {
  const { values } = usePaymentContext();
  const { setFieldValue } = usePaymentContextApi();
  const formik = useFormik({ initialValues: INITIAL_VALUES, onSubmit: () => {} });

  useEffect(() => {
    setFieldValue('method', method);
    setFieldValue('methodDetail', null);
    if (patientId) setFieldValue('saveCard', true);
  }, [method, patientId, setFieldValue]);

  // The Converge lightbox is opened by the footer Pay button, so the address the patient types
  // has to live on the payment form the charge is built from.
  useEffect(() => {
    setFieldValue('billingAddress', buildBillingAddress(formik.values));
  }, [formik.values, setFieldValue]);

  return (
    <FormikProvider value={formik}>
      <div className="flex w-full flex-col gap-4">
        <ElavonCardForm patientId={patientId} hideButton showCardholderName={false} />
        {!values.tempCard && (
          <Checkbox
            size={16}
            isChecked={values.saveCard}
            onChange={(event) => setFieldValue('saveCard', event.target.checked)}
            className="max-w-[456px] self-start"
            innerLabelClassName="items-start"
            labelClassName="text-xs leading-[14px] font-medium"
            label="Save this card for future payments."
          />
        )}
      </div>
    </FormikProvider>
  );
};

export default ElavonManualEntry;
